import React, { useMemo } from 'react';
import { Column, Row } from '../../components/Grid/Grid';
import Image from '../../components/Image/Image';
import Text from '../../components/Text/Text';
import Currency from '../../components/Currency/Currency';
import useProductDecorator from './useProductDecorator';
import useStyles from './styles';
import { LeftSpaced } from '../../components/Spaced/Spaced';

function ProductDetails({ product }: ProductDetailsProps) {
  const { decorate } = useProductDecorator();
  const classes = useStyles();

  const decoratedProduct = useMemo(() => decorate(product), [product]);

  return (
    <div className={classes.productDetailsContainer}>
      <Row justifyContent="space-between">
        <Column>
          <Row>
            <Image
              src={decoratedProduct.object.imageUrl}
              alt={decoratedProduct.object.name}
              className={classes.productImage}
            />
            <LeftSpaced>
              <Column>
                <Text type="primary-bold">{decoratedProduct.object.name}</Text>
                <Text type="subtitle">{decoratedProduct.count}</Text>
              </Column>
            </LeftSpaced>
          </Row>
        </Column>
        <Column>
          <Currency textType="bold" value={decoratedProduct.object.price} />
        </Column>
      </Row>
    </div>
  );
}

export default ProductDetails;
